export default __webpack_public_path__ + "static/media/helen.a3cb38f9.jpg";